import { render, staticRenderFns } from "./BlockCapabilities.vue?vue&type=template&id=1e048112&scoped=true&lang=pug&"
import script from "./BlockCapabilities.vue?vue&type=script&lang=ts&"
export * from "./BlockCapabilities.vue?vue&type=script&lang=ts&"
import style0 from "./BlockCapabilities.vue?vue&type=style&index=0&id=1e048112&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e048112",
  null
  
)

export default component.exports